import authServices from "app/services/auth-services";
import { useEffect, useState } from "react";

const usePlans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await authServices.pricingPlans();
        setPlans(response);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching plans:", err);

        const errorResponse = err.response?.data || {
          message: err.message || "Failed to fetch plan details",
          status: err.response?.status || 400,
        };
        setError(errorResponse);
        setLoading(false);
      }
    };
    fetchPlans();
  }, []);

  return { plans, loading, error };
};

export default usePlans;
